module.exports = __webpack_public_path__ + "static/media/america.dadcac06.svg";